var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgList(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.125 7.5L5.625 7.5M13.125 3.75L5.625 3.75M13.125 11.25L5.625 11.25M3.125 7.5C3.125 7.84518 2.84518 8.125 2.5 8.125C2.15482 8.125 1.875 7.84518 1.875 7.5C1.875 7.15482 2.15482 6.875 2.5 6.875C2.84518 6.875 3.125 7.15482 3.125 7.5ZM3.125 3.75C3.125 4.09518 2.84518 4.375 2.5 4.375C2.15482 4.375 1.875 4.09518 1.875 3.75C1.875 3.40482 2.15482 3.125 2.5 3.125C2.84518 3.125 3.125 3.40482 3.125 3.75ZM3.125 11.25C3.125 11.5952 2.84518 11.875 2.5 11.875C2.15482 11.875 1.875 11.5952 1.875 11.25C1.875 10.9048 2.15482 10.625 2.5 10.625C2.84518 10.625 3.125 10.9048 3.125 11.25Z",
    stroke: "#808795",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgList);
export default __webpack_public_path__ + "static/media/list.3ccdec90c9c5318a0e3e272ac2680c63.svg";
export { ForwardRef as ReactComponent };